import { useTranslation } from "react-i18next";
import { CardHeader } from "components";
import { Step } from "helpers";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthPasswordResetForm } from "./components/AuthPasswordResetForm";

interface AuthPasswordResetProps {
  setEmail: Dispatch<SetStateAction<string>>;
}

export const AuthPasswordReset = ({ setEmail }: AuthPasswordResetProps) => {
  const { t, i18n } = useTranslation();
  const [step, setStep] = useState<Step>(0);
  const [title, setTitle] = useState<string>("");
  const [paragraph, setParagraph] = useState<string>("");

  useEffect(() => {
    if (step === 0) {
      setTitle(t("auth.resetPassword"));
      setParagraph(t("auth.enterEmailToReceiveLink"));
    } else {
      setTitle(t("auth.passwordResetSent"));
      setParagraph(t("auth.checkYourEmail"));
    }
  }, [step, i18n.language]); // <-- depend on the actual language, not just t

  return (
    <>
      <CardHeader title={title} paragraph={paragraph} withLanguage={step === 0} />
      {step === 0 ? (
        <AuthPasswordResetForm setStep={setStep} onEmailSent={setEmail} />
      ) : (
        <Link to="/" className="mt-7">
          {t("auth.backToLogin")}
        </Link>
      )}
    </>
  );
};
